var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 419,
    viewBox: "0 0 254 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M209.4 147.4L74.9 12.7998C57.9 -4.2002 30.2 -4.2002 13.2 12.7998C-3.80002 29.7998 -3.80002 57.4998 13.2 74.4998L116.9 178.2C133.9 195.2 133.9 222.9 116.9 239.9L13.1 343.7C-3.90002 360.7 -3.90002 388.4 13.1 405.4C30.1 422.4 57.8 422.4 74.8 405.4L209.4 270.8L240.3 239.9C257.3 222.9 257.3 195.2 240.3 178.2L209.4 147.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9dc3d842f43633092a573872a3c0fbf4.svg";
export { ForwardRef as ReactComponent };